import React from 'react';
import { useEffect, useRef, useState, createRef } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  SActionBtn,
  SLowcodeList,
  SDrawer,
  STableActions,
  SIDRender,
  SFuncModal
} from 'shj-components'
import { getAuth } from '@/utils/auth'
import config from './config';
import { Button, Form, Input, message, Modal, Table } from 'antd'
import { AddOrEditForm } from './components/addOrEdit'
import { refundApplyPageList, refundApplyUpdateRefundApplyInfo,
   refundApplyUpdateRefundApplyPayState, refundApplyConfirmToAccountForHandle,
   refundApplyReceiveToAccountForHandle } from '@/services/fmsServices'
const { TextArea } = Input;
export default function PaymentServiceManage(props) {
  const auth = getAuth()
  const history = useNavigate();
  const [openModal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [editData, setEditData] = useState<any>(null);
  const listRef = useRef<any>();
  const childRef = createRef<any>()
  const { id, orderId, dealMode } = props
  let [form] = Form.useForm();
  useEffect(() => {
    if (id) {
      reloadFn();
    }
  }, [id]);
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        query.orderId = orderId
        refundApplyPageList(current, pageSize, query).then((res) => {
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  // 右侧表格事件：
  const onSkip = () => {
    // 判断签约方式跳转
    if(dealMode === 'DIRECT'){
      //直接付款
      history('/order/list/details/direct-index/' + orderId)
    }else{
      history('/order/list/details/' + orderId)
    }
  }
  const onChangeRecord = (record) => {
    history('/fms/paymentService/changeRecord/' + record.id)
  }
  const onEdit = (record: any) => {
    setEditData({ ...record, type: 'edit' })
    setModal(true)
  }
  const onHandle = (record: any) => {
    setEditData({ ...record, type: 'handle' })
    setModal(true)
  }

  const onSave = () => {
    childRef.current?.validateFields().then(async (values: any) => {
      setLoading(true)
      refundApplyUpdateRefundApplyInfo({
        id: values.id,
        bankNetworkNumber: values.bankNetworkNumber,
        bankAddress: values.bankAddress,
        accountNumber: values.accountNumber,
        accountName: values.accountName,
        accountNature: values.accountNature,
      }).then(res => {
        message.success(res.message || '提交成功')
        reloadFn()
        setModal(false)
        setLoading(false)
      }).catch(err => {
        setLoading(false)
      })
    })
  }
  const onSubmit = () => {
    childRef.current?.validateFields().then(async (values: any) => {
      setLoading(true)
      refundApplyConfirmToAccountForHandle({
        id: values.id,
      }).then(res => {
        message.success(res.message || '操作成功')
        reloadFn()
        setModal(false)
        setLoading(false)
      }).catch(err => {
        setLoading(false)
      })
    })
  }
  const onConfirm = () => {
    childRef.current?.validateFields().then(async (values: any) => {
      setLoading(true)
      refundApplyReceiveToAccountForHandle({
        id: values.id,
      }).then(res => {
        message.success(res.message || '操作成功')
        reloadFn()
        setModal(false)
        setLoading(false)
      }).catch(err => {
        setLoading(false)
      })
    })
  }
  const onDetail = (record: any) => {
    setEditData({ ...record, type: 'see' })
    setModal(true)
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      resolve({})
    })
  }
  const onFinish = () => {
    form.validateFields().then((values) => {
      setLoading(true)
      refundApplyUpdateRefundApplyPayState({
        id: editData?.id,
        payExceptionDescription: values.payExceptionDescription
      }).then(res => {
        message.success(res.message || '操作成功')
        reloadFn()
        setUpdateStatus(false)
        setLoading(false)
      }).catch(err => {
        setLoading(false)
      })
    })
  }
  const onUpdatePaymentStatus = (record: any) => {
    console.log('更新支付状态', record);
    setEditData(record)
    setUpdateStatus(true)
  }

  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onSkip },
    status: {
      skipDisabled: () => !orderId,
    },
    customRender: {
      IdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => onDetail(record)} copy={false}></SIDRender>
        )
      },
      renderOperate(_, record: Record<string, any>) {
        return (
          <STableActions>
            {
             record.refundState !== 'confirmToAccount' ? <SActionBtn auth="RefundConfirmationHandle" onClick={() => onHandle(record)}>处理</SActionBtn>:null
            }
            
            <SActionBtn auth="RefundConfirmationEdit" onClick={() => onEdit(record)}>修改</SActionBtn>
            {
              record.payState === 'refundPayStateFailure' ? <SActionBtn auth="RefundConfirmationUpdatePaymentStatus" onClick={() => onUpdatePaymentStatus(record)}>更新支付状态</SActionBtn>:null
            }
            <SActionBtn auth="RefundConfirmationChangeRecord" onClick={() => onChangeRecord(record)}>变更历史</SActionBtn>
          </STableActions>
        )
      },
    },
  }
  return (
    <div>
      <SLowcodeList config={config} ref={listRef} tableType="antd" {...extension} 
        searchMode="group"
        summary={() => {
          const dataSource = listRef.current?.getDataSource() || [];
          if (dataSource.length === 0) {
            return null; // 没有数据时不显示 Table.Summary
          }
          const totalAmounts = dataSource.reduce(
            (totals, record) => {
              totals.refund += record.refundAmount || 0;
              return totals;
            },
            { refund: 0 }
          );
          const formatAmount = (amount) => Number(amount).toFixed(2);
          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                <Table.Summary.Cell index={2}>合计</Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  {formatAmount(totalAmounts.refund)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
      {/* 新增弹出抽屉层 */}
      {/* 线下收款 */}
      <SDrawer
        title={editData?.type === 'handle' ? '退款申请处理' : editData?.type === 'edit' ? '退款申请修改' : '退款申请查看'}
        width="50%"
        isHideResetBtn={false}
        footer={editData?.type === 'edit' ? [
          <Button onClick={() => setModal(false)}>取消</Button>,
          <Button loading={loading} type='primary' style={{ marginLeft: 10 }} onClick={onSave}>保存</Button>,
        ] : editData?.type === 'handle' ? [
          editData?.refundState === 'refundStateNotConfirm' ?
          auth['RefundConfirmationConfirm'] && (<Button loading={loading} type='primary' style={{ marginLeft: 10 }} onClick={onConfirm}>确认退款</Button>) :
            editData?.refundState === 'refundStateReceiveToAccount' ? auth['RefundConfirmationRefunded'] && (<Button type='primary' loading={loading} style={{ marginLeft: 10 }} onClick={onSubmit}>已退款</Button>) : null
        ] : []}
        open={openModal}
        onClose={() => setModal(false)}
        destroyOnClose
      >
        <AddOrEditForm ref={childRef} editData={editData} />
      </SDrawer>
      <Modal
        title="是否更新退款支付状态为退款成功？"
        open={updateStatus}
        closable={true}
        confirmLoading={loading}
        maskClosable={true}
        onOk={onFinish}
        onCancel={() => { setUpdateStatus(false) }}
      >
        <div style={{marginTop: 20}}>
          <Form
            form={form}
            autoComplete="off"
          >
            <Form.Item
              label="处理结果"
              name="payExceptionDescription"
              rules={[{ required: true, message: '请输入处理结果' }]}
            >
              <TextArea rows={4} placeholder="请输入处理结果" maxLength={50} />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  )
}